



























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import MerchantIDTooltip from '@/components/MerchantIDTooltip/MerchantIDTooltip.vue';
import AdminService from '@/api/AdminService';
import eventBus from '@/utils/eventBus';
@Component({
  components: {
    FlexButton,
    TextInput,
    SideModalHeader,
    MerchantIDTooltip
  },
  $_veeValidate: { validator: 'new' }
})
export default class ModalMID extends Vue {
  @Prop({ default: null }) data!: any;

  service: AdminService = new AdminService();
  merchantID: string = '';
  confirmMerchantID: string = '';

  errorsBag: string[] = [];
  loading: boolean = false;

  get BusinessName() {
    return this.data.name;
  }

  removeError(field: string) {
    this.errorsBag = this.errorsBag.filter(e => e !== field);
  }

  validate() {
    if (!this.merchantID || this.merchantID.length < 5) {
      this.errorsBag.push('mid');
      this.$notification(
        'Make sure the Merchant ID is, at least, 5 characters long',
        'error'
      );
    } else if (
      !this.confirmMerchantID ||
      this.confirmMerchantID !== this.merchantID
    ) {
      this.errorsBag.push('confirm-mid');
      this.$notification(
        'You must confirm the merchant ID. Check the highlighted field.',
        'error'
      );
    }
  }

  submit() {
    this.validate();
    if (this.errorsBag.length) return;
    this.loading = true;
    this.service
      .setBusinessMerchantID(this.data.id, {
        merchantId: this.merchantID
      })
      .then(res => {
        if (res.status === 200) {
          this.$notification('Merchant ID updated successfully');
          eventBus.$emit('setSideModalVisible', false);
          eventBus.$emit('reloadBusinessList');
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
